import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
interface ProjectCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  href: string;
  delay?: number;
}
export function ProjectCard({
  title,
  description,
  icon,
  href,
  delay = 0
}: ProjectCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay
  }} className="bg-white rounded-lg p-8 shadow-lg" data-id="element-105">
      <div className="text-[var(--color-primary)] mb-4" data-id="element-106">{icon}</div>
      <h3 className="text-[var(--color-text)] mb-4" data-id="element-107">{title}</h3>
      <p className="text-[var(--color-text-light)] mb-6 leading-relaxed" data-id="element-108">
        {description}
      </p>
      <Button variant="outline" href={href} size="sm" data-id="element-109">
        Learn More
      </Button>
    </motion.div>;
}